import React from 'react'
import styled from 'styled-components'
import YoorDoor1 from '../../images/yoor_door_1.svg'
import FooterView from 'components/Footer'
import logo from 'components/landingpage/assets/logo.webp'
import Container from 'components/common/Container'

export default function Maintenance() {
  return (
    <React.Fragment>
      <header className="global-header global-header-center">
        <div className="logo">
          <a href={'/'}>
            <Logo src={logo} alt="YOOR" />
          </a>
        </div>
      </header>
      <Container>
        <div className="contents">
          <div className="contents-header">
            <h1>
              <span style={{ color: '#ffc107' }}>&#x26a0;</span>
              ただいまメンテナンス中です。
            </h1>
          </div>
          <div className="contents-body">
            <p className="text-center mb20">
              <img src={YoorDoor1} alt="yooricon" />
            </p>
            <div className="text-center">
              いつもYOORをご利用頂きありがとうございます。
              <br />
              <br />
              ただいまメンテナンス中です。
              <br />
              恐れ入りますが、今しばらくお待ちください。
              <br />
              <br />
            </div>
            {/* <div className="mt30 mb20">
              <a href="/" className="btn btn-submit btn-block">
                トップページへ
              </a>
            </div> */}
            <div className="text-sm mb30 text-center">
              ※メンテナンス状況については、
              <a target="_blank" href="https://x.com/yoor_jp">
                YOOR公式ツイッター
              </a>
              にてお知らせさせていただいております。
            </div>
          </div>
        </div>
      </Container>
      <FooterView />
    </React.Fragment>
  )
}

const Logo = styled.img`
  width: 90px;
  height: 23px;
  @media (max-width: 640px) {
    width: 63px;
    height: 18px;
  }
`
